import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { RenderContextComponent } from '../../../../../../../models/base/render-context-component';
import type { ProductMenu } from '../../../../../../../models/menu/product-menu';
import { ResizeObserver } from '@juggle/resize-observer';
import { HtmlUtils } from '../../../../../../../utils/html-utils';
import { exists } from '../../../../../../../functions/exists';

@Component({
  selector: 'app-menu-section-plus-x-more',
  templateUrl: './menu-section-plus-x-more.component.html',
  standalone: false
})
export class MenuSectionPlusXMoreComponent extends RenderContextComponent {
  @ViewChild('sectionItem') sectionItem: ElementRef;
  @Input() menu: ProductMenu;
  @Input() howManyAdditionalItems: number;
  @Output() sectionHeightInPx: EventEmitter<number> = new EventEmitter<number>(true);
  public ro: ResizeObserver;

  setupBindings() {
    this.observePlusXMoreContainer();
  }

  setupViews() {}

  observePlusXMoreContainer() {
    this.ro = new ResizeObserver((entries, _) => {
      HtmlUtils.getElementTotalHeightAsync(this.sectionItem.nativeElement).then(height => {
        if (this.howManyAdditionalItems > 0) {
          this.sectionHeightInPx.emit(height);
        } else {
          this.sectionHeightInPx.emit(0);
        }
      });
    });
    // Element for which to observe height and width
    if (exists(this.sectionItem)) {
      this.ro.observe(this.sectionItem.nativeElement);
    }
  }

  destroy() {
    super.destroy();
    this.ro?.disconnect();
  }
}
